export enum CauseEnum {
  PAYMENT = "PAYMENT",
  REFUND = "REFUND"
}
